import httpService from "./http.service";

class ShippingMethodsService {
  getShippingMethodsUrl = "/delivery-methods";

  getShippingMethods = () => {
    return httpService.get(this.getShippingMethodsUrl);
  };
  createShippingMethod = (model) => {
    return httpService.post("/delivery-methods", model);
  };
  editShippingMethod = (id, model) => {
    return httpService.patch("/delivery-methods/" + id, model);
  };
  deleteShippingMethod = (id) => {
    return httpService.delete("/delivery-methods/" + id);
  };
}

const shippingMethodsService = new ShippingMethodsService();
export default shippingMethodsService;
